if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.geolocation = document.querySelector('geolocation-change');

        this.select = this.querySelector('.localization__dropdown');
        this.select.addEventListener('change', this.onSelectChange.bind(this));
      }

      onSelectChange(event) {
        event.preventDefault();

        let location = this.select.value;

        this.geolocation.setAttribute('data-locale', location);
        this.geolocation.show();
      }
    }
  );
}
